import { useMemo } from 'react';
import { useStores } from 'hooks';
import { modifyLocaleParam } from '../util/locale-param-transformer';

export const useLocaleParam = () => {
  const { uiStore, context } = useStores();
  const { locale } = context;

  const { signInUrl, signUpUrl } = uiStore;
  const localeParam = ['locale', modifyLocaleParam(locale)].join('=');

  return useMemo(() => {
    const signinLink = signInUrl ? [signInUrl, localeParam].join('?') : `/${modifyLocaleParam(locale)}/signin`;
    const signupLink = signUpUrl ? [signUpUrl, localeParam].join('?') : `/${modifyLocaleParam(locale)}/signup`;

    return { signupLink, signinLink };
  }, [locale]);
};
